import React, { Component, useState, useEffect, useMemo } from "react";
import "./App.css";
import { defaultTheme } from "react-admin";
import authProvider from "./authProvider";
import NewAuthProvider from "./NewAuthProvider";
import { Admin, Resource, EditGuesser } from "react-admin";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import myRestProvider from "./myRestProvider";
import Dashboard from "./dashboard/Dashboard";
import MyLoginPage from "./login_page";
import MyNewLoginPage from "./new_login_page";

import { GetCurrentUserRoles, googleRecaptchaKey } from "./common/common";
import { ComplaintMenu } from "./common/common";

import polyglotI18nProvider from "ra-i18n-polyglot";

import SapSdoDispute from "./sap_sdo_dispute";
import SapProducts from "./sap_contract_products";
import SapPayers from "./sap_contract_payers";
// import RetailerContracts from './retailer_contracts';
import digitalOrders from "./digitalOrders";
import uploadPDF from "./uploadPDF";
import DigitalOrdersLineItemEdit from "./DigitalOrderLineItems/DigitalOrderLineItemsEdit";
import digitalOrderTrans from "./digitalOrderTrans";
import singleDeliveryOrders from "./singleDeliveryOrders";
import { PostList } from "./proofOfPayments/post";
import { PostEdit } from "./proofOfPayments/post";
import { CreateProofOfPayment } from "./proofOfPayments/create";
import businesses from "./businesses";
// import whitelistUsers from './whiteListUsers1';
import {
  WhiteListUsersList,
  WhiteListUsersEdit,
  WhiteListUsersCreate,
} from "./whiteListUsers/posts";
import TermsConditionsList from "./termsCondition/TermsConditionHistoryList";
import RegisteredUsersList from "./registeredUsers/RegisteredUsersList";
import TermsConditionEdit from "./termsCondition/TermsConditionEdit";
import { TermsConditionsChangeLogList } from "./termsCondition/TermsConditionHistory";
import { SettingList } from "./settings";
import { SettingChangeLogList } from "./settings/changeLogList";

import { ChangeLogList } from "./whiteListUsers/changeLogList";
// import PostShow  from './whiteListUsers1/postShow';
import contracts from "./contracts";
import shipTos from "./shipTos";
import clickItUser from "./clickItUser";
import sapMaterialsForSdos from "./sapMaterialsForSdos";
// import salesOfficers from './salesOfficersOld'
import salesOfficers from "./salesOfficers";
import businessTargets from "./businessTargets";
import loyaltyPoints from "./loyaltyPoints";
import complaintManagements from "./complaintManagements";
import InAppNotification from "./inAppNotification";
import SoAppNotification from "./soAppNotification";
import SendMessage from "./sendMessage";
import Promotions from "./promotions";
import Surveys from "./survey";
import SoSendMessage from "./soSendMessage";
import BulkInAppNotification from "./bulkInAppNotification";
import BulkSendMessage from "./bulkSendMessage";

import { ProductList } from "./productList";
import { ProductChangeLogList } from "./productList/changeLogList";
import discountSchemes from "./discountSchemes";
import DiscountSchemesCreateTwo from "./discountSchemes/discountSchemesCreateTwo";
import Payments from "./Payments";

import customRoutes from "./customRoutes";
import englishMessages from "./enM";
import englishKenyaMessages from "./enKEM";
import * as Colors from "@mui/material/colors";

import { createTheme } from "@mui/material/styles";
import MyLayout from "./MyLayout";
import NotFound from "./NotFound";

import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  loginType,
  getLocalStorageKey,
} from "./common/common";
import probasePayments from "./probasePayments";
import PriceUpdate from "./priceUpdateMadagaskar";
import DiliverySMS from "./diliverySMS/index";
import BulkOrderBlockUpload from "./BulkOrderBlockUpload";
import DashboardBanners from "./dashboardBanners";
import DashboardBannersWeb from "./dashboardBannersWeb";
import emailerBanners from "./emailerBanners";
import ProductImages from "./productImages";
import deliveryTickets from "./deliveryTickets";
import AdminPanelUsers from "./settings/adminPanelUsers";
import NotificationList from "./settings/notificationList";

import { requestForToken, onMessageListener, messaging } from "./firebase";
import { getNotificationPermission } from "./Notification";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import { onMessage } from "firebase/messaging";
import { useNavigate } from "react-router-dom";
// import uploadZIP from "./uploadZIP";

const ClickitTheme = (baseThemeColor) => ({
  ...defaultTheme,
  typography: {
    fontFamily: ["Holcim-Regular"].join(","),
  },
  components: {
    ...defaultTheme.components,
    RaAppBar: {
      styleOverrides: {
        root:
        baseThemeColor === 'clickittheme'
          ? {
              backgroundColor: "#53a5ec",
            }
          : {
              backgroundImage: "linear-gradient(45deg, #103776 0%, #01FBFF 100%)",
            },
      },
    },
  },
});

const NavendorTheme = createTheme({
  palette: {
    primary: Colors.lightBlue,
    secondary: Colors.red,
    error: Colors.red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: ["NeueEinstellung", "Arial", "sans-serif"].join(","),
  },

  overrides: {
    MuiButton: {
      // override the styles of all instances of this component
      root: {
        // Name of the rule
        // color: '#000!important',
        fontSize: "12px!important",
        // background: '#2d88e9!important',
        // padding: '1px 16px!important',
        minHeight: "32px!important",
        borderRadius: "2px!important",
      },

      label: {
        textTransform: "capitalize!important",
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: "1rem!important",
        lineHeight: "inherit!important",
        whiteSpace: "inherit!important",
        height: "inherit!important",
      },
    },
    MuiAppBar: {
      root: {
        background: "#eec900!important",
        color: "#000!important",
        position: "absolute",
        // '&:after': {
        //     content: '""',
        //     position: 'absolute',
        //     left: '10px',
        //     top:'3px',
        //     padding:'0',
        //     backgroundImage: 'url(../../../navendor-logo.svg)',
        //     backgroundRepeat: 'no-repeat',
        //     backgroundColor: '#eec900',
        //     backgroundPosition:'-120px 14px',
        //     backgroundSize: '148px',
        //     height: '40px',
        //     width: '36px',
        //     display: 'block',
        // }
      },
    },
    MuiToolbar: {
      root: {
        textAlign: "center",
        minHeight: "56px",
      },
      dense: {
        minHeight: "56px",
      },
    },

    MuiCard: {
      root: {
        overflow: "inherit!important",
        overflowY: "auto!important",
      },
    },
    MuiTable: {
      root: {
        overflow: "auto!important",
        width: "100%",
        borderCollapse: "initial!important",
        paddingLeft: "10px",
      },
    },
    MuiInput: {
      root: {
        width: "100%",
      },
      underline: {
        "&:after": {
          borderBottomColor: "#eec900",
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "rgba(0, 0, 0, 0.54)!important",
        },
      },
    },
    MuiLinearProgress: {
      bar: {
        backgroundColor: "#eec900!important",
      },
      colorPrimary: {
        backgroundColor: "#ccc!important",
      },
    },
    MuiTabs: {
      root: {
        marginTop: "40px",
        width: "100%",
      },
      // fixed:{
      //     overflow:'scroll',
      //     background:'#fff',
      // },
      // flexContainer:{
      //     overflow:'scroll',
      // },
      indicator: {
        background: "none",
      },
    },
    MuiTableCell: {
      head: {
        fontSize: "14px!important",
        minWidth: "100px!important",
        fontWeight: "bold!important",
        padding: "10px!important",
        background: "#e3e3e3",
      },
      body: {
        fontSize: "12px!important",
        padding: "10px!important",
        minWidth: "100px!important",
        whiteSpace: "nowrap",
      },
      numeric: {
        textAlign: "left",
        flexDirection: "initial",
      },
    },
    MuiFormControl: {
      marginNormal: {
        // minWidth: '200px!important',
        marginLeft: "5px",
        width: "100%",
      },
    },
    MuiTablePagination: {
      toolbar: {
        width: "90px",
      },
    },
    MuiSvgIcon: {
      root: {
        // fontSize:'20px!important',
      },
    },
    MuiTypography: {
      subheading: {
        whiteSpace: "nowrap",
      },
    },
  },
});

const i18nProvider = polyglotI18nProvider((locale) => {
  let messages = englishMessages;
  switch (locale) {
    case "en-UG":
    case "en-KE":
      messages = englishKenyaMessages;
      break;
    default:
      messages = englishMessages;
      break;
  }
  return messages;
});

const renderResources = (props) => {
  // console.log('ResourceRoleWrapper', props);
  let roleData = GetCurrentUserRoles();
  let complaint = ComplaintMenu();
  console.log("loginType=====>", loginType);
  const resources = [
    <Resource
      name="businesses"
      options={{ label: "Retailers" }}
      {...businesses}
    />,
    <Resource
      name="proof_of_payments"
      list={PostList}
      edit={PostEdit}
      create={CreateProofOfPayment}
      options={{ label: "Proof record" }}
    />,
    <Resource
      name="dashboard_banners"
      {...DashboardBanners}
      options={{ label: "Dashboard Banner" }}
    />,
    <Resource
      name="emailer_banners"
      {...emailerBanners}
      options={{ label: "Emailer Banner" }}
    />,
    <Resource
      name="dashboard_banners_web"
      {...DashboardBannersWeb}
      options={{ label: "Dashboard Banner Web" }}
    />,
    <Resource
      name="productsmaster"
      {...ProductImages}
      options={{ label: "Product Images" }}
    />,
    <Resource
      name="sap_digital_orders"
      options={{ label: "All orders viewed via app" }}
      {...digitalOrders}
    />,
    <Resource
      name="sap_digital_order_line_items"
      options={{ label: "Line Items" }}
      edit={DigitalOrdersLineItemEdit}
    />,
    <Resource
      name="digital_order_transactions"
      options={{ label: "Digital Order Transactions" }}
      {...digitalOrderTrans}
    />,
    <Resource
      name="sap_digital_app_orders"
      options={{ label: " " }}
      {...digitalOrders}
    />,
    <Resource name="sap_digital_order_line_items" options={{ label: " " }} />,
    <Resource
      name="sap_digital_disputed_orders"
      options={{ label: "Disputed Orders" }}
      {...digitalOrders}
    />,
    <Resource
      name="received_digital_orders"
      options={{ label: "Received Digital Orders" }}
      {...digitalOrders}
    />,
    <Resource
      name="sap_contracts"
      options={{ label: "Contracts" }}
      {...contracts}
    />,
    <Resource
      name="sap_sdo_dispute"
      options={{ label: "Delivery Dispute" }}
      show={SapSdoDispute}
    />,
    <Resource
      name="sap_contract_products"
      options={{ label: "Products" }}
      show={SapProducts}
    />,
    <Resource
      name="sap_contract_payers"
      options={{ label: "Payers" }}
      show={SapPayers}
    />,
    <Resource
      name="sap_business_sites"
      options={{ label: "Ship-To" }}
      {...shipTos}
    />,
    <Resource
      name="sms_delivery_reports"
      options={{ label: "sms_reports" }}
      list={DiliverySMS}
    />,
    <Resource
      name="sap_sdo_for_orders"
      options={{ label: " " }}
      {...singleDeliveryOrders}
    />,
    <Resource
      name="sap_materials_for_sdos"
      options={{ label: "SDO Materials" }}
      {...sapMaterialsForSdos}
    />,
    <Resource
      name="sales_officers"
      options={{ label: "Sales Officers" }}
      {...salesOfficers}
    />,
    <Resource
      name="business_targets"
      options={{ label: "Targets" }}
      {...businessTargets}
    />,
    <Resource
      name="loyalty_points"
      options={{ label: "Loyalty Points" }}
      {...loyaltyPoints}
    />,
    <Resource
      name="probase_payments"
      options={{ label: "Probase Payments" }}
      {...probasePayments}
    />,
    <Resource
      name="in_app_notifications"
      options={{ label: "Notification" }}
      {...InAppNotification}
    />,
    <Resource
      name="so_in_app_notifications"
      options={{ label: "So Notification" }}
      {...SoAppNotification}
    />,
    <Resource
      name="sms_blasts"
      options={{ label: "Marketing" }}
      {...SendMessage}
    />,
    <Resource
      name="so_sms_blasts"
      options={{ label: " " }}
      {...SoSendMessage}
    />,
    <Resource
      name="in_app_sold_to_list"
      options={{ label: " " }}
      {...InAppNotification}
    />,
    <Resource
      name="surveys_sold_to_list"
      options={{ label: "Sold To List" }}
      {...Surveys}
    />,
    <Resource
      name="so_in_app_sold_to_list"
      options={{ label: " " }}
      {...SoAppNotification}
    />,
    <Resource
      name="terms_and_condition_list"
      list={TermsConditionsList}
      options={{ label: "Terms and Conditions List" }}
    />,
    <Resource
      name="clickit_signup_customers"
      list={RegisteredUsersList}
      options={{ label: "Registered Users" }}
    />,
    <Resource
      name="term_and_conditions"
      list={TermsConditionEdit}
      options={{ label: "Terms and Conditions" }}
    />,
    <Resource
      name="sms_blast_sold_to_list"
      options={{ label: "Sold To List" }}
      {...SendMessage}
    />,
    <Resource
      name="promotions"
      options={{ label: "Promotion Notifications" }}
      {...Promotions}
    />,
    <Resource
      name="surveys"
      options={{ label: "Survey Notifications" }}
      {...Surveys}
    />,
    <Resource name="survey_targeted_features" />,
    <Resource
      name="promotion_sold_to_list"
      options={{ label: "Promotion Sold To List" }}
      {...Promotions}
    />,
    <Resource
      name="so_sms_blast_sold_to_list"
      options={{ label: " " }}
      {...SoSendMessage}
    />,
    <Resource
      name="send_bulk_notifications"
      options={{ label: "Bulk Notification" }}
      {...BulkInAppNotification}
    />,
    <Resource
      name="bulk_notification_sold_to_list"
      options={{ label: " " }}
      {...BulkInAppNotification}
    />,
    <Resource
      name="send_sms_bulk_notifications"
      options={{ label: "Bulk Message" }}
      {...BulkSendMessage}
    />,
    <Resource
      name="send_sms_bulk_sold_to_list"
      options={{ label: " " }}
      {...BulkSendMessage}
    />,
    // <Resource name="complaints" options={{ label: 'Complaint Management' }} {...complaintManagements} />,
    <Resource
      {...props}
      name="sap_contracts_product_list"
      list={ProductList}
      options={{ label: "Product list" }}
    />,
    <Resource
      name="track_logs_history"
      list={ProductChangeLogList}
      options={{ label: "track_logs_history" }}
    />,
    <Resource
      name="discount_scheme_assignment/:id"
      list={DiscountSchemesCreateTwo}
      options={{ label: "discount_scheme_assignment" }}
    />,

    <Resource name="sap_plants" />,
    <Resource name="getSapDetails" />,
    <Resource
      name="track_trems_logs_history"
      list={TermsConditionsChangeLogList}
      options={{ label: "track_trems_logs_history" }}
    />,
    <Resource
      name="madagascar_products_list"
      {...PriceUpdate}
      options={{ label: "Price Update" }}
    />,
    <Resource
      name="order_block_create"
      list={BulkOrderBlockUpload}
      options={{ label: "Ordering Blocked Upload" }}
    />,
    <Resource
      name="users"
      options={{ label: "Click it Users" }}
      {...clickItUser}
    />,
    <Resource
      name="discount_schemes"
      options={{ label: "Discount Schemes" }}
      {...discountSchemes}
    />,
    <Resource
      name="customer_file_downloads"
      options={{ label: "Pdf Uploads" }}
      {...uploadPDF}
    />,
    <Resource
      name="voucher_assigend_list"
      options={{ label: "Voucher assigned List" }}
      {...discountSchemes}
    />,
    <Resource
      name="voucher_unassigend_list"
      options={{ label: "Voucher unassigned List" }}
      {...discountSchemes}
    />,
    <Resource
      name="payment_intents"
      options={{ label: "Payments List" }}
      {...Payments}
    />,
    <Resource
      name="delivery_tickets"
      options={{ label: " " }}
      {...deliveryTickets}
    />,
    <Resource
      name="admin_panel_users"
      edit={AdminPanelUsers}
      options={{ label: "Admin Panel Users" }}
    />,
    <Resource
      {...props}
      name="chat_list"
      list={NotificationList}
      options={{ label: "Notification List" }}
    />,
  ];
  if (roleData && (roleData[0] === "$ca" || roleData[0] === "$csa")) {
    resources.push(
      <Resource
        {...props}
        name="whitelist_users"
        create={WhiteListUsersCreate}
        edit={WhiteListUsersEdit}
        list={WhiteListUsersList}
        options={{ label: "Whitelist users" }}
      />
    );
    resources.push(
      <Resource
        name="change_log"
        list={ChangeLogList}
        options={{ label: "change_log" }}
      />
    );
  }
  if (roleData && roleData[0] === "$csa") {
    resources.push(
      <Resource
        {...props}
        name="settings"
        list={SettingList}
        options={{ label: "settings" }}
      />
    );
    resources.push(
      <Resource
        name="settings_change_log"
        list={SettingChangeLogList}
        options={{ label: "settings_change_log" }}
      />
    );
  }
  // if (roleData && roleData[0] === '$ca') {
  //     resources.push(<Resource name="settings" options={{ label: 'Settings' }} list={SettingList} />)
  //     resources.push(<Resource name="settings_change_log" list={SettingChangeLogList} options={{ label: 'settings Change Log' }} />)
  // }
  if (complaint) {
    resources.push(
      <Resource
        name="complaints"
        options={{ label: "Complaint Management" }}
        {...complaintManagements}
      />
    );
  }
  return resources;
};

const App = () => {
  const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");
  const localStorageAppType = getLocalStorageKey("app_type");

  // Create theme object from current state
  useEffect(() => {
  const interval = setInterval(() => {
    const appType = localStorage.getItem("app_type");
    if (appType) {
      if (appType === "HOLCIM") {
        setBaseThemeColor("holcimtheme");
        document.title = "HOLCIM+ Admin Dashboard";
        const favicon = document.getElementById("favicon");

        if (favicon) {
        favicon.href = "/favicon2.ico";
        }
      } else {
        setBaseThemeColor("clickittheme");
         document.title = "Clickit Admin Dashboard";
        const favicon = document.getElementById("favicon");
        if (favicon) {
        favicon.href = "/favicon.ico";
        }
      }

      // Stop checking once app_type is available
      clearInterval(interval);
    }
  }, 50);

  // Cleanup if the component unmounts
  return () => clearInterval(interval);
}, []);
  
  const theme = useMemo(
    () => ClickitTheme(baseThemeColor),
    [baseThemeColor]
  );

  const setupInterval = (callback, interval, name) => {
    var key = "_timeInMs_" + (name || "");
    var now = Date.now();
    var timeInMs = localStorage.getItem(key);
    var executeCallback = function () {
      localStorage.setItem(key, Date.now());
      callback();
    };
    if (timeInMs) {
      // User has visited
      var time = parseInt(timeInMs);
      var delta = now - time;
      if (delta > interval) {
        // User has been away longer than interval
        setInterval(executeCallback, interval);
      } else {
        // Execute callback when we reach the next interval
        setTimeout(function () {
          setInterval(executeCallback, interval);
          executeCallback();
        }, interval - delta);
      }
    } else {
      setInterval(executeCallback, interval);
    }
    localStorage.setItem(key, now);
  };

  /*------------------------*/
  // const navigate = useNavigate();
  // const id = getLocalStorageKey("id");
  // const [isPermissionModalOpen,setIsPermissionModalOpen] = React.useState(true);
  // const [isUserInteracted, setIsUserInteracted] = React.useState(false);
  // const audio = new Audio('/public/notification.mp3');

  // const [notification, setNotification] = React.useState({title: '', body: ''});
  // const notify = () => (
  //         Swal.fire({
  //             html: `Title: ${notification.title}  Body: ${notification.body}`,
  //             icon: "success",
  //           })
  // );

  // const redirectToSap = (data) => {
  //   window.open(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`, "_blank");
  //   navigate(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`);
  // };

  // React.useEffect(()=>{

  //     onMessage(messaging, (payload) => {
  //         console.log("foreground payload", payload);
  //         // handleForegroundMessage();
  //         setNotification({title: payload?.notification?.title, body: payload?.notification?.body});
  //         const notificationTitle = payload.notification.title;
  //         const notificationBody = payload.notification.body;
  //         const notificationOptions = {
  //           body: payload.notification.body,
  //           sound: 'default',
  //           icon : 'https://homepages.cae.wisc.edu/~ece533/images/zelda.png'

  //         };
  //         const notification = new Notification(notificationTitle, {
  //           body: notificationBody,
  //           icon: './images/navender_logo.png', // Path to the icon image
  //           data: { url: 'https://developer.mozilla.org/' } // Custom data, if needed
  //         });

  //         notification.onclick = (event) => {
  //           const redirectUrl = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ? `http://localhost:3000/sap_digital_app_orders/${payload?.data?.sap_digital_order_id}/show/3`:`${process.env.API_URL}/sap_digital_app_orders/${payload?.data?.sap_digital_order_id}/show/3`;
  //           window.open(redirectUrl,"_blank");
  //         };
  //     });
  // },[]);

  // React.useEffect(()=>{
  //     if (notification?.title ){
  //         notify()
  //         }
  // },[notification])

  // async function notificationPermission(){
  //     console.log('hi i a here in this app js')
  //     await getNotificationPermission(id).then(() =>{
  //       setIsPermissionModalOpen(false);
  //     })
  //   }

  // function displayPermissionModal(){
  //     console.log('wasssssssssssssssssupppppppp');
  //     return(
  //         <Modal open={isPermissionModalOpen} onClose={()=>setIsPermissionModalOpen(!isPermissionModalOpen)} center>
  //         <h3>{'modalMsg'}</h3>
  //             <button onClick={notificationPermission}>click me</button>
  //         </Modal>
  //     )
  // }

  /*------------------------*/

  return (
    <React.Fragment>
      {loginType === "password_based" ? (
        <GoogleReCaptchaProvider
          reCaptchaKey={googleRecaptchaKey}
          language="en"
          useRecaptchaNet="true"
        >
          {/* {isPermissionModalOpen &&
            !(Notification.permission === "granted") && (
              <Modal
                open={isPermissionModalOpen}
                onClose={() => setIsPermissionModalOpen(false)}
                center
              >
                <div className="an-txt">
                  Please click on Allow when the browser asks you to provide
                  access to notifications so that you can receive chat
                  notifications.
                </div>
                <button className="an-btn" onClick={notificationPermission}>
                  OK
                </button>
              </Modal>
            )} */}
          <Admin
            loginPage={MyNewLoginPage}
            catchAll={NotFound}
            i18nProvider={i18nProvider}
            layout={MyLayout}
            // theme={NavendorTheme}
            theme={theme}
            dashboard={Dashboard}
            authProvider={NewAuthProvider}
            dataProvider={myRestProvider}
            title=""
            customRoutes={customRoutes}
          >
            {renderResources}
          </Admin>
        </GoogleReCaptchaProvider>
      ) : (
        <>
          {/* {isPermissionModalOpen &&
            !(Notification.permission === "granted") && (
              <Modal
                open={isPermissionModalOpen}
                onClose={() => setIsPermissionModalOpen(false)}
                center
              >
                <div className="an-txt">
                  Please click on Allow when the browser asks you to provide
                  access to notifications so that you can receive chat
                  notifications.
                </div>
                <button className="an-btn" onClick={notificationPermission}>
                  OK
                </button>
              </Modal>
            )} */}
          <Admin
            loginPage={MyLoginPage}
            catchAll={NotFound}
            i18nProvider={i18nProvider}
            layout={MyLayout}
            // theme={NavendorTheme}
            theme={theme}
            dashboard={Dashboard}
            authProvider={authProvider}
            dataProvider={myRestProvider}
            title=""
          >
            {renderResources}
          </Admin>
        </>
      )}
    </React.Fragment>
  );
};
export default App;
